

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import excel from 'exceljs';
import { ValidationObserver } from 'vee-validate';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import FileIcon from 'mdi-vue/File';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import DownloadIcon from 'mdi-vue/Download';

import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import BatchInvoiceTable from './BatchInvoiceTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    SearchIcon,
    DownloadIcon,
    FileIcon,
    SearchRow,
    SearchField,
    Select,
    BatchInvoiceTable,
    Modal,
    FormInput,
    ValidationObserver,
  },
  computed: mapState(['user']),
})
export default class BatchInvoice extends Vue {
  user!: {
    user: User;
  };

  loadingExport = false;
  dataSearch = '';

  $refs!: {
    report: BatchInvoiceTable;
  }

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  mounted() {
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  search() {
    this.$router.push({
      query: {
        sc: this.dataSearch === null ? undefined : this.dataSearch,
      },
    });
  }

  parseParams() {
    const params = this.$route.query;
    if (typeof params.sc === 'string') {
      const dtsearch = params.sc.toString();
      if (dtsearch) {
        this.dataSearch = dtsearch;
      } else {
        this.dataSearch = '';
      }
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getBatchInvoice(page);
  }

  async getBatchInvoice(page: number) {
    const params = {
      datasearch: this.dataSearch,
    };
    await this.$refs.report.getBatchInvoice(params, page);
  }

  async exportData() {
    this.loadingExport = true;
    /* eslint-disable */
    try {
      const { data } = await api.post('easyinvoice/invoices_list_batch_download', {
        /* eslint-disable-next-line @typescript-eslint/camelcase */
        user_group: 5,
        merch_id: this.user.user.merchant_id,
      });
      const workbook = new excel.Workbook();
      workbook.created = dayjs().toDate();
      const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });
      sheet.getRow(1).font = { bold: true };
      sheet.columns = [
        { header: 'File Name', width: 50 },
        { header: 'Status', width: 20 },
        { header: 'Created At	', width: 30 },
      ];
      data.forEach((item: any) => {
        sheet.addRow([
          item.filename_ori,
          item.status,
          item.created_at,
        ]);
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const filename = `'Report-Invoices-Bulk-Batch-List'-${new Date().toLocaleDateString()}.xlsx`;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingExport = false;
      showToast(ToastType.SUCCESS, 'Export Report', 'Export finished');
    } catch (err) {
      this.loadingExport = false;
      showToast(ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`, 'Failed to export Report');
    }
    /* eslint-enable */
  }
}
